import { useSelector, useDispatch } from 'react-redux';
import { useMemo, useCallback } from 'react';
import FJConstant from '../../../../constants/FJConstant';
import FJUtil from '../../../../util/FJUtil';
import FJObjectEraseText from '../view/FJObjectEraseText';
import PropTypes from 'prop-types';
import { setSliceTextPrompt } from '../../../../redux/slices/FJSliceObjectErase';

const FJObjectEraseTextContainer = ({ isShow }) => {
    const dispatch = useDispatch();
    const isNotImage = useSelector(state => state.objectErase.inputImageInfo === null);
    const taskStatus = useSelector(state => state.objectErase.textEraseTaskStatus);
    const textPrompt = useSelector(state => state.objectErase.textPrompt);

    const _onChangeTextPrompt = useCallback(
        e => {
            dispatch(setSliceTextPrompt(e.target.value));
        },
        [dispatch],
    );

    const isDisabled = useMemo(() => {
        return FJUtil.isGeneratingStatus(taskStatus) || taskStatus === FJConstant.ERROR;
    }, [taskStatus]);

    return (
        <FJObjectEraseText
            isNotImage={isNotImage}
            disabled={isDisabled}
            taskStatus={taskStatus}
            isShow={isShow}
            textPrompt={textPrompt}
            onChangeTextPrompt={_onChangeTextPrompt}
        />
    );
};

FJObjectEraseTextContainer.propTypes = {
    isShow: PropTypes.bool,
};

export default FJObjectEraseTextContainer;
